import * as Sentry from "@sentry/react";

const DSN = import.meta.env.VITE_SENTRY_DSN;
const ENV =
  import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || "development";

if (DSN) {
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    enabled: ENV !== "development",
    sendDefaultPii: false,
  });
}

import React from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./contexts/AuthContext";
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE } from "./lib/constants";
import ErrorBoundary from "./components/ErrorBoundary";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Auth0Provider
          domain={AUTH0_DOMAIN}
          clientId={AUTH0_CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: AUTH0_AUDIENCE,
          }}
        >
          <AuthProvider>
            <App />
          </AuthProvider>
        </Auth0Provider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
